module.exports = __webpack_public_path__ + "static/media/andriod12.d79a191b.png";